export default {
  LOGIN_IN(state:any, value:any) {
    state.token.accessToken = value.accessToken
    state.adminInfo = value.adminInfo
    state.systemConfig = value.systemConfig
    state.activeMenu=[]
  },
  LOGIN_OUT(state:any) {    
    state.token.accessToken  = ''
    state.adminInfo = {}
    state.systemConfig = {}
    state.activeMenu=[]
    window.localStorage.removeItem('vuex')
  },
  ACTIVEMENU_SET(state:any, value:any){    
    let falg=false
    for(let i=0;i<state.activeMenu.length;i++){
      if(state.activeMenu[i].path==value.path){
        state.activeMenu[i].status = true        
        falg = true
      }else{
        state.activeMenu[i].status = false
      }
    }    
    if(state.activeMenu.length==0 || !falg){      
      state.activeMenu.push(value)
    }   
  },
  ACTIVEMENU_SET_STATUS(state:any){
    for(let i=0;i<state.activeMenu.length;i++){     
      state.activeMenu[i].status = false    
    }
  },
  ACTIVEMENU_DEL_PATH(state:any,path:any){
    let cont=state.activeMenu.length       
    for(let i=0;i<cont;i++){ 
      if(state.activeMenu[i].path == path){            
        if(i!=0 && cont>1 && state.activeMenu[i].status){
          state.activeMenu[i-1].status=true          
        }      
        state.activeMenu.splice(i, 1); 
        cont--         
      }           
    }  
  },
  ACTIVEMENU_DEL(state:any,type:any){
    let cont=state.activeMenu.length   
            
    for(let i=0;i<cont;i++){ 
      if(type=='none' && state.activeMenu[i].status){
        if(i!=0 && cont>1 ){
          state.activeMenu[i-1].status=true                   
        } 
        state.activeMenu.splice(i, 1); 
        cont--   
      }else if(type=='left'){
        if(state.activeMenu[i].status){
          return
        }
        state.activeMenu.splice(i, 1); 
        cont--  
        i--
      }else if(type=='right'){
        if(state.activeMenu[i].status){
          state.activeMenu.splice(i+1, cont-i-1);
          return 
        }
      }else if(type=='other'){
        if(state.activeMenu[i].status){
          state.activeMenu.splice(i+1, cont-i-1);
          return 
        }else{
          state.activeMenu.splice(i, 1); 
          cont--  
          i--
        }
      }else if(type=='all'){       
        state.activeMenu.splice(i, 1); 
        cont--  
        i--
      }  
    }  
  },
  ACTIVE_THEME_SET(state:any,value:any){
    state.systemSet.activeTheme=value
  },
  LOGOFALG_SET(state:any){
    state.systemSet.logoFalg=!state.systemSet.logoFalg
  },
  TABFALG_SET(state:any){
    state.systemSet.tabFalg=!state.systemSet.tabFalg
  }
}


